import { Image } from "primereact/image";
import MeaPage from "../../../components/MeaPage";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import schoolsAPI from "../../../services/schools";
import { InputText } from "primereact/inputtext";
import MeaButton from "../../../components/MeaButton";
import { PERMISSION_SCHOOL_DETAILS } from "../../../permissions";
import { BreadCrumb } from "primereact/breadcrumb";
import MeaLink from "../../../components/MeaLink";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { useParams } from "react-router-dom";

const AboutPage = () => {
    const params = useParams();

    const [school, setSchool] = useState(null);
    const { hasPermission } = useAuthContext();

    const [name, setName] = useState(school?.name);
    const [presentation, setPresentation] = useState(school?.presentation);
    const [address, setAddress] = useState(school?.address);
    const [city, setCity] = useState(school?.city);
    const [postal_code, setPostalCode] = useState(school?.postal_code);
    const [country, setCountry] = useState(school?.country);
    const [phone, setPhone] = useState(school?.phone);
    const [email, setEmail] = useState(school?.email);
    const [website, setWebsite] = useState(school?.website);
    const [facebook, setFacebook] = useState(school?.facebook);
    const [twitter, setTwitter] = useState(school?.twitter);
    const [youtube, setYoutube] = useState(school?.youtube);
    const [tiktok, setTiktok] = useState(school?.tiktok);
    const [instagram, setInstagram] = useState(school?.instagram);
    const [linkedin, setLinkedin] = useState(school?.linkedin);
    const [avatar, setAvatar] = useState(
        school?.avatar
            ? school?.avatar + "?" + school?.updated_at
            : "/School.jpeg"
    );

    const [refresh, setRefresh] = useState(new Date());
    useEffect(() => {
        schoolsAPI.GetOneSchool(params.schoolId).then((data) => {
            setSchool(data?.data);
        });
    }, [params.schoolId, refresh]);

    useEffect(() => {
        setName(school?.name);
        setPresentation(school?.presentation);
        setAddress(school?.address);
        setCity(school?.city);
        setPostalCode(school?.postal_code);
        setCountry(school?.country);
        setPhone(school?.phone);
        setEmail(school?.email);
        setWebsite(school?.website);
        setFacebook(school?.facebook);
        setTwitter(school?.twitter);
        setYoutube(school?.youtube);
        setTiktok(school?.tiktok);
        setInstagram(school?.instagram);
        setLinkedin(school?.linkedin);
        setAvatar(school?.avatar
            ? school?.avatar + "?" + school?.updated_at
            : "/images/school-empty-logo.svg");
    }, [school]);



    const handleUpdateSchoolSubmit = async (e) => {
        e.preventDefault();
        schoolsAPI
            .UpdateOne(school?.id, "", {
                name: name,
                presentation: presentation,
                address: address,
                city: city,
                postal_code: postal_code,
                country: country,
                phone: phone,
                email: email,
                website: website,
                facebook: facebook,
                twitter: twitter,
                youtube: youtube,
                tiktok: tiktok,
                instagram: instagram,
                linkedin: linkedin,
            })
            .then((data) => {
                toast.current.show({
                    severity: "success",
                    summary: "Succès",
                    detail: "Informations de l'école mis à jour!",
                    life: 3000,
                });
                setRefresh(new Date());
            })
            .catch((err) => {
                toast.current.show({
                    severity: "error",
                    summary: "Erreur",
                    detail: "Erreur de mise à jour des informations de l'école!",
                    life: 3000,
                });
            });
    };
    const toast = useRef(null);

    const breadcrum = [
        {
            label: 'Components',
            template: () => <MeaLink to={`/school/${school?.id}/admin`} icon="pi pi-home" isRipple={true}>{school?.name}</MeaLink>
        },
        { label: 'A propos de l\'école' }
    ];

    return (
        <>
            <Toast ref={toast} position="bottom-center" />
            <MeaPage
                breadcrumb={<BreadCrumb model={breadcrum} />}
                title="A propos de l'école"
                showBackButton={false}
            >
                <div className="grid mb-5 ml-5">
                    <div className="col-12 lg:col-3">
                        <div className="text-900 font-medium text-xl mb-3">
                            Photo de profil de l'école
                        </div>
                        <p className="m-0 p-0 text-400 line-height-2 text-sm mr-3">
                            256 x 256 pixels.
                        </p>
                    </div>
                    <div className="col-12 lg:col-9">
                        <div className="w-full lg:w-6 ">
                            <div className="card flex flex-wrap gap-3 p-fluid">
                                <Image
                                    src={avatar}
                                    zoomSrc={avatar}
                                    alt="Image"
                                    width="120"
                                    height="120"
                                    imageStyle={{ borderRadius: '50%' }}
                                    preview
                                />
                            </div>
                            <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                                <div className="flex">
                                    {hasPermission(PERMISSION_SCHOOL_DETAILS.UPDATE) && <FileUpload
                                        mode="basic"
                                        name="file"
                                        customUpload
                                        uploadHandler={async (event) => {
                                            await schoolsAPI
                                                .UpdateAvatar(school?.id, "", event.files[0])
                                                .then((data) => {
                                                    toast.current.show({
                                                        severity: "info",
                                                        summary: "Succès",
                                                        detail: "La photo de profil de l'école a été modifiée!",
                                                        life: 3000,
                                                    });
                                                    setRefresh(new Date());
                                                })
                                                .catch((err) => {
                                                    toast.current.show({
                                                        severity: "error",
                                                        summary: "Erreur",
                                                        detail:
                                                            "Erreur de modification de la photo de profil de l'école!",
                                                        life: 3000,
                                                    });
                                                    setRefresh(new Date());
                                                }).finally(() => {
                                                    event.options.clear();
                                                });
                                        }}
                                        accept="image/*"
                                        maxFileSize={10000000}
                                        auto
                                        chooseLabel="Modifier"
                                    />}
                                    <MeaButton label="Supprimer la photo" permission={PERMISSION_SCHOOL_DETAILS.UPDATE} outlined className="p-button-danger ml-1" onClick={async () => {
                                        await schoolsAPI
                                            .DeleteAvatar(school?.id, "")
                                            .then((data) => {
                                                toast.current.show({
                                                    severity: "info",
                                                    summary: "Succès",
                                                    detail: "La photo de profil de l'école a été supprimée!",
                                                    life: 3000,
                                                });
                                                setRefresh(new Date());
                                            })
                                            .catch((err) => {
                                                toast.current.show({
                                                    severity: "error",
                                                    summary: "Erreur",
                                                    detail:
                                                        "Erreur de suppression de la photo de profil de l'école!",
                                                    life: 3000,
                                                });
                                                setRefresh(new Date());
                                            });
                                    }
                                    } />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid mb-5 mt-3 ml-5">
                    <div className="col-12 lg:col-3">
                        <div className="text-900 font-medium text-xl mb-3">
                            Mes informations de base
                        </div>
                        <p className="m-0 p-0 text-400 line-height-2 text-sm mr-3">
                            Les informations de base de l'école.
                        </p>
                    </div>
                    <div className="col-12 lg:col-9">
                        <div className="w-full lg:w-6 ">
                            <div className="card flex flex-wrap gap-3 p-fluid">
                                <div className="flex-auto">
                                    <label htmlFor="minmax" className="font-bold block mb-2">
                                        Nom de l'école
                                    </label>
                                    <InputText
                                        className="flex-1 w-full"
                                        disabled={!hasPermission(PERMISSION_SCHOOL_DETAILS.UPDATE)}
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                                <div className="flex-auto">
                                    <label htmlFor="minmax" className="font-bold block mb-2">
                                        Présentation
                                    </label>
                                    <InputText
                                        className="flex-1 w-full"
                                        disabled={!hasPermission(PERMISSION_SCHOOL_DETAILS.UPDATE)}
                                        value={presentation}
                                        onChange={(e) => setPresentation(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                                <div className="flex-auto">
                                    <label htmlFor="minmax" className="font-bold block mb-2">
                                        Adresse
                                    </label>
                                    <InputText
                                        className="flex-1 w-full"
                                        disabled={!hasPermission(PERMISSION_SCHOOL_DETAILS.UPDATE)}
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                                <div className="flex-auto">
                                    <label htmlFor="minmax" className="font-bold block mb-2">
                                        Ville
                                    </label>
                                    <InputText
                                        className="flex-1 w-full"
                                        disabled={!hasPermission(PERMISSION_SCHOOL_DETAILS.UPDATE)}
                                        value={city}
                                        onChange={(e) => setCity(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                                <div className="flex-auto">
                                    <label htmlFor="minmax" className="font-bold block mb-2">
                                        Code postal
                                    </label>
                                    <InputText
                                        className="flex-1 w-full"
                                        disabled={!hasPermission(PERMISSION_SCHOOL_DETAILS.UPDATE)}
                                        value={postal_code}
                                        onChange={(e) => setPostalCode(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                                <div className="flex-auto">
                                    <label htmlFor="minmax" className="font-bold block mb-2">
                                        Pays
                                    </label>
                                    <InputText
                                        className="flex-1 w-full"
                                        disabled={!hasPermission(PERMISSION_SCHOOL_DETAILS.UPDATE)}
                                        value={country}
                                        onChange={(e) => setCountry(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                                <div className="flex-auto">
                                    <label htmlFor="minmax" className="font-bold block mb-2">
                                        Téléphone de contact
                                    </label>
                                    <InputText
                                        className="flex-1 w-full"
                                        disabled={!hasPermission(PERMISSION_SCHOOL_DETAILS.UPDATE)}
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                                <div className="flex-auto">
                                    <label htmlFor="minmax" className="font-bold block mb-2">
                                        Email de contact
                                    </label>
                                    <InputText
                                        className="flex-1 w-full"
                                        disabled={!hasPermission(PERMISSION_SCHOOL_DETAILS.UPDATE)}
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                                <div className="flex-auto">
                                    <label htmlFor="minmax" className="font-bold block mb-2">
                                        Site web de l'école
                                    </label>
                                    <InputText
                                        className="flex-1 w-full"
                                        disabled={!hasPermission(PERMISSION_SCHOOL_DETAILS.UPDATE)}
                                        value={website}
                                        onChange={(e) => setWebsite(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                                <div className="flex-auto">
                                    <label htmlFor="minmax" className="font-bold block mb-2">
                                        Facebook de l'école
                                    </label>
                                    <InputText
                                        className="flex-1 w-full"
                                        disabled={!hasPermission(PERMISSION_SCHOOL_DETAILS.UPDATE)}
                                        value={facebook}
                                        onChange={(e) => setFacebook(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                                <div className="flex-auto">
                                    <label htmlFor="minmax" className="font-bold block mb-2">
                                        Twitter de l'école
                                    </label>
                                    <InputText
                                        className="flex-1 w-full"
                                        disabled={!hasPermission(PERMISSION_SCHOOL_DETAILS.UPDATE)}
                                        value={twitter}
                                        onChange={(e) => setTwitter(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                                <div className="flex-auto">
                                    <label htmlFor="minmax" className="font-bold block mb-2">
                                        Youtube de l'école
                                    </label>
                                    <InputText
                                        className="flex-1 w-full"
                                        disabled={!hasPermission(PERMISSION_SCHOOL_DETAILS.UPDATE)}
                                        value={youtube}
                                        onChange={(e) => setYoutube(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                                <div className="flex-auto">
                                    <label htmlFor="minmax" className="font-bold block mb-2">
                                        Tiktok de l'école
                                    </label>
                                    <InputText
                                        className="flex-1 w-full"
                                        disabled={!hasPermission(PERMISSION_SCHOOL_DETAILS.UPDATE)}
                                        value={tiktok}
                                        onChange={(e) => setTiktok(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                                <div className="flex-auto">
                                    <label htmlFor="minmax" className="font-bold block mb-2">
                                        Instagram de l'école
                                    </label>
                                    <InputText
                                        className="flex-1 w-full"
                                        disabled={!hasPermission(PERMISSION_SCHOOL_DETAILS.UPDATE)}
                                        value={instagram}
                                        onChange={(e) => setInstagram(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                                <div className="flex-auto">
                                    <label htmlFor="minmax" className="font-bold block mb-2">
                                        Linkedin de l'école
                                    </label>
                                    <InputText
                                        className="flex-1 w-full"
                                        disabled={!hasPermission(PERMISSION_SCHOOL_DETAILS.UPDATE)}
                                        value={linkedin}
                                        onChange={(e) => setLinkedin(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="card flex mt-3">
                                <MeaButton
                                    outlined
                                    permission={PERMISSION_SCHOOL_DETAILS.UPDATE}
                                    disabled={
                                        school?.name === name &&
                                        school?.presentation === presentation &&
                                        school?.address === address &&
                                        school?.city === city &&
                                        school?.postal_code === postal_code &&
                                        school?.country === country &&
                                        school?.phone === phone &&
                                        school?.email === email &&
                                        school?.website === website &&
                                        school?.facebook === facebook &&
                                        school?.twitter === twitter &&
                                        school?.youtube === youtube &&
                                        school?.tiktok === tiktok &&
                                        school?.instagram === instagram &&
                                        school?.linkedin === linkedin
                                    }
                                    onClick={handleUpdateSchoolSubmit}
                                >
                                    Enregistrer
                                </MeaButton>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="grid mb-5 ml-5">
                    <div className="col-12 lg:col-3">
                        <div className="text-900 font-medium text-xl mb-3">
                            Logo de l'école
                        </div>
                        <p className="m-0 p-0 text-400 line-height-2 text-sm mr-3">
                            245 x 50 pixels.
                        </p>
                    </div>
                    <div className="col-12 lg:col-9">
                        <div className="w-full lg:w-6 ">
                            <div className="card flex flex-wrap gap-3 p-fluid">
                                <Image
                                    src={logo}
                                    zoomSrc={logo}
                                    alt="Image"
                                    width="245"
                                    height="50"
                                    preview
                                />
                            </div>
                            <div className="card flex flex-wrap gap-3 p-fluid mt-3">
                                <div className="flex">
                                    {hasPermission(PERMISSION_SCHOOL_DETAILS.UPDATE) && <FileUpload
                                        mode="basic"
                                        name="file"
                                        customUpload
                                        uploadHandler={async (event) => {
                                            await schoolsAPI
                                                .UpdateLogo(school?.id, auth?.access_token, event.files[0])
                                                .then((data) => {
                                                    //setCurrentAccount(data?.data);
                                                    toast.current.show({
                                                        severity: "info",
                                                        summary: "Succès",
                                                        detail: "Le logo de l'école a été modifié!",
                                                        life: 3000,
                                                    });
                                                    reloadCurrentMembership();
                                                })
                                                .catch((err) => {
                                                    toast.current.show({
                                                        severity: "error",
                                                        summary: "Erreur",
                                                        detail:
                                                            "Erreur de modification du logo de l'école!",
                                                        life: 3000,
                                                    });
                                                    //setRefresh(new Date());
                                                }).finally(() => {
                                                    event.options.clear();
                                                });
                                        }}
                                        accept="image/*"
                                        maxFileSize={10000000}
                                        auto
                                        chooseLabel="Modifier"
                                    />}
                                    <MeaButton permission={PERMISSION_SCHOOL_DETAILS.UPDATE} label="Supprimer" outlined className="p-button-danger" onClick={async () => {
                                        await schoolsAPI
                                            .DeleteLogo(school?.id, auth?.access_token)
                                            .then((data) => {
                                                //setCurrentAccount(data?.data);
                                                toast.current.show({
                                                    severity: "info",
                                                    summary: "Succès",
                                                    detail: "La logo de l'école a été supprimé!",
                                                    life: 3000,
                                                });
                                                reloadCurrentMembership();
                                            })
                                            .catch((err) => {
                                                toast.current.show({
                                                    severity: "error",
                                                    summary: "Erreur",
                                                    detail:
                                                        "Erreur de suppression du logo de l'école!",
                                                    life: 3000,
                                                });
                                                //setRefresh(new Date());
                                            });
                                    }
                                    } />
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

            </MeaPage>
        </>
    );
}
export default AboutPage; 